import React from 'react'
import Icon from '@components/Icon';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import Text from '@components/Text';
import Link from '../Link';

export interface ContactItemProps{
  id?: string | undefined;
  iconName?: string | undefined;
  title?: string | undefined;
  link?: string | undefined;
  description1?: string | undefined;
  description2?: string | undefined;
  url?: string | undefined;
}

const Container = styled.div`
  display:inline-flex;
  flex:0 0 372px;
  flex-direction:row;
  @media screen and (max-width: 767px) {
    flex:0 0 100%;
  }
`
const LeftContainer = styled.div`
  flex:0;
`
const RightContainer = styled.div`
  flex:1;
  flex-direction:column;
  @media screen and (max-width: 767px) {
    margin-right:0;
  }
`
const TitleContainer = styled.div`
  margin-bottom:8px
`
const LinkContainer = styled.div`
  margin-bottom:8px
`
const DescriptionContainer = styled.div`
`

const IconClass = css`
  width:60px;
  height:60px;
  margin-right:16px;
`

const TitleClass = css`
  font-family: 'Open Sans';
  font-style: normal;
  line-height: 120%;
`
const SubTitleClass = css`
  a{
    font-family: 'Open Sans';
    line-height: 140%;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.08em;
  }
`
const DescriptionClass = css`
  font-family: 'Open Sans';
  font-style: normal;
  line-height: 120%;
  letter-spacing: 0.015em;
`

export default function ContactItem({id,iconName,title,link,description1,description2,url}:ContactItemProps) {
  return (
    <Container>
      <LeftContainer>
        <Icon className={IconClass} name={iconName} />
      </LeftContainer>
      <RightContainer>
        <TitleContainer><Text className={TitleClass} color={"#1E1E1E"} fontSize={20} fontWeight={600}>{title}</Text></TitleContainer>
        <LinkContainer><Link hoverUnderline={true} className={SubTitleClass} color={"#883E89"} fontSize={16} fontWeight={600} url={url} text={link} /></LinkContainer>
        <DescriptionContainer><Text className={DescriptionClass} fontSize={16} fontWeight={400} color={"#434343"}>{description1}</Text></DescriptionContainer>
        <DescriptionContainer><Text className={DescriptionClass} fontSize={16} fontWeight={400} color={"#434343"}>{description2}</Text></DescriptionContainer>
      </RightContainer>
    </Container>
  )
}
